import { Box, Grid } from '@mui/material';
import { ISubmissionSettingsResponse } from 'wisestep-api';
import { Label, WsSelect } from 'wisestep-base';

import { useBusinessUnitContext } from '../../../context';

interface BusinessUnit {
  submissionSetting: ISubmissionSettingsResponse | null;
  name: string;
  defaultValue?: string;
}

const BusinessUnit = ({ submissionSetting, name, defaultValue }: BusinessUnit) => {
  const businessUnits = useBusinessUnitContext();

  return (
    <Grid item xs={8.25} m={2}>
      {!submissionSetting?.businessUnit?.hidden && businessUnits.length > 0 && (
        <>
          <Label>{`Business Unit ${submissionSetting?.businessUnit?.required ? '*' : ''}`}</Label>
          <Box>
            <WsSelect
              name={name}
              selectArray={businessUnits?.map((bu) => ({
                label: bu.name ?? '',
                value: bu.id ?? '',
              }))}
              placeholder="Select business Unit"
              variant="outlined"
              size="small"
              defaultValue={defaultValue}
            />
          </Box>
        </>
      )}
    </Grid>
  );
};
export default BusinessUnit;
